import { Common } from "./Common";

export class CommitteeMember extends Common {
  
  committee_id: string;
  emp_id: string;

  status?: string | null;         // e.g., 'pending', 'approved'
  role?: string | null;           // e.g., 'President', 'Member'
  designation?: string | null;    // job title
  profile_meta?: any | null;      // use `any` for JSON object
  dob?: Date | null;            // date in YYYY-MM-DD format
  remarks?: string | null;
  meta?: any | null;              // custom additional fields
}
